import React from "react";
import { ValueLabel } from "@features/ax/shared/ValueLabel";

interface OverviewTabProps {
  routeDetails?: any;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ routeDetails }) => {
  const route = routeDetails;

  const activeStatus = route?.isActive !== false ? "Active" : "Inactive";
  const totalStops = route?.premiseCount ?? 'NA';
  const assignedTo =
    route?.assignedReader ||
    route?.assignedTo ||
    "NA";

  const routeSummaryItems = [
    {
      label: "Route Name",
      value: route?.routeName || "NA",
    },
    {
      label: "Premise",
      value: Array.isArray(route?.premiseName)
        ? route.premiseName.join(", ")
        : "NA",
    },
    {
      label: "Area",
      value: Array.isArray(route?.areaName)
        ? route.areaName.join(", ")
        : route?.areaName || "NA",
    },
    {
      label: "Read Cycle",
      value: route?.readCycleName || route?.readCycleDisplay || "NA",
    },
    {
      label: "Total Premises",
      value: totalStops,
    },
    {
      label: "Assigned To",
      value: assignedTo,
    },
    {
      label: "Last Read",
      value: route?.lastReadDate || "NA",
    },
  ];

  const statusBadge = (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${activeStatus === "Active"
          ? "bg-emerald-50 text-emerald-600 border border-emerald-200"
          : "bg-gray-100 text-gray-600 border border-gray-200"
        }`}
    >
      {activeStatus}
    </span>
  );

  const statusItems = [
    {
      label: "Status",
      value: statusBadge,
    },
    {
      label: "Created On",
      value: route?.createdDate || "2024/01/15",
    },
    {
      label: "Created By",
      value: route?.createdUserRemoteName || "System Admin",
    },
  ];

  return (
    <div className="space-y-6 pt-2">
      {/* 1. Route Summary Section */}
      <div className="space-y-2">
        <h3 className="text-xs font-bold text-gray-500 tracking-wider">
          Route Summary
        </h3>
        <div className="bg-sky-50/40 border border-sky-100/80 rounded-xl p-5 shadow-2xs">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-6">
            {routeSummaryItems.map((item) => (
              <ValueLabel
                key={item.label}
                label={item.label}
                value={item.value}
              />
            ))}
          </div>
        </div>
      </div>

      {/* 2. Status Details Section */}
      <div className="space-y-2">
        <h3 className="text-xs font-bold text-gray-500 tracking-wider">
          Status Details
        </h3>
        <div className="bg-sky-50/40 border border-sky-100/80 rounded-xl p-5 shadow-2xs">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-6">
            {statusItems.map((item) => (
              <ValueLabel
                key={item.label}
                label={item.label}
                value={item.value}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default OverviewTab;
